module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_04_6NV26_1SA_H2G.a35fef05.jpg";